export const SOLUTION_DEMO_EXPORT_CONFIG = {
  drawerTitle: 'Export Dashboard',
  dashboardTitle: 'Solution Demo Analytics Export',
  fileNamePrefix: 'solution-demo-analytics',
  imageFilePrefix: 'solution-demo',
  imageZipFileName: 'solution-demo-analytics-images.zip',
  filterFields: [
    { key: 'bootcampName', label: 'Bootcamp Name' },
    { key: 'region', label: 'Region' },
    { key: 'org', label: 'Org' },
    { key: 'certificationStatus', label: 'Certification Status' },
    { key: 'cohort', label: 'Cohort' },
  ],
  sections: [
    {
      title: 'Cohorts & Organization',
      items: [
        { id: 'export-certification-outcomes', label: 'Certification Outcomes by Cohort' },
        { id: 'export-organization-breakdown', label: 'Breakdown by Organization Type' },
      ],
    },
    {
      title: 'Countries',
      items: [
        { id: 'export-top-countries', label: 'Top Countries — Certifications' },
        { id: 'export-country-detail', label: 'All Countries · Certification Detail' },
      ],
    },
    {
      title: 'Companies',
      items: [
        { id: 'export-top-companies', label: 'Top Companies — Total Participants' },
        { id: 'export-company-scorecard', label: 'Company Certification Scorecard' },
      ],
    },
    {
      title: 'Certification Progress',
      items: [
        { id: 'export-certification-rate-region', label: 'Certification Rate by Region' },
        { id: 'export-certification-trend-cohort', label: 'Certification Trend by Cohort' },
      ],
    },
    {
      title: 'Follow-up',
      items: [
        { id: 'export-champion-workload', label: 'Champion Follow-up Workload' },
        { id: 'export-participants-followup', label: 'Participants Requiring Follow-up' },
      ],
    },
  ],
};

export { buildFilterSummary, getExportItemIds, getExportItemsById } from './exportConfigUtils';
